var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-select-screen"},[_c('div',{staticClass:"image-select-container"},_vm._l((_vm.referenceImages),function(image){return _c('div',{key:image.name,class:[
        'image-select-item',
        {
          selected:
            _vm.selectedReferenceImg && _vm.selectedReferenceImg.name === image.name
        }
      ]},[_c('a',{attrs:{"tabindex":"0","href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.setSelection(image)}}},[_c('img',{staticClass:"img-fluid",attrs:{"src":require(("../assets/" + (image.src)))}})])])}),0),_c('button',{on:{"click":function($event){return _vm.finishSelection()}}},[_vm._v("Next")])])}
var staticRenderFns = []

export { render, staticRenderFns }